import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'displayName'
})
export class DisplayNamePipe implements PipeTransform {
  transform(address: any): string {
    if(address) {
      const { firstname, lastname } = address;

      if (!firstname && !lastname) return '';
  
      return ((firstname ? firstname.trim() : '') + ' ' + (lastname ? lastname.trim() : '')).trim();    
    }
  }
}


// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/shared/pipes/display-name.pipe.ts